import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import ErrAlert from "@material-ui/icons/Error";

// core components
import Snackbar from "components/Snackbar/Snackbar.jsx";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import { AuthConsumer } from "react-check-auth";

import { MemberLogin } from "actions/MemberAction.jsx";
import { isLocal, localLicenseRenewDate } from "../../lib/config";

const styles = theme => ({
  layout: {
    width: "auto",
    display: "block", // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
});

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      tc: false,
      msg: "",
      licenseAvail: true,
    };
    this.alertTimeout = null;
  }

  componentDidMount() {
    if(isLocal === "true") {
      this.checkLicense();
    }
  }

  componentWillUnmount() {
    this.clearAlertTimeout();
  }

  checkLicense = function() {
    // check license renewal date
    let licenseRenewDate = new Date(localLicenseRenewDate);
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const daysBetween = this.daysBetween(today, licenseRenewDate);

    if (daysBetween < 1) {
      const expiredMessage = isLocal === "true" || isLocal === true
        ? "License is expired!\nPlease click Renew License and follow the instructions to send a renewal token to our support team."
        : "License is expired!\nPlease contact our support team for renewal.";
      alert(expiredMessage);
      this.setState({licenseAvail:false});
    }
  }

  daysBetween = function( date1, date2 ) {
    //Get 1 day in milliseconds
    var one_day=1000*60*60*24;
  
    // Convert both dates to milliseconds
    var date1_ms = date1.getTime();
    var date2_ms = date2.getTime();
  
    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;
  
    // Convert back to days and return
    return Math.round(difference_ms/one_day); 
  }

  /*function ReportView(props) {
  state = {
    email: "",
    password: "",
    tc: true,
  };*/

  handleChanged = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  clearAlertTimeout = () => {
    if (this.alertTimeout !== null) {
      clearTimeout(this.alertTimeout);
    }
  };

  showNotification = msg => {
    this.setState({
      tc: true,
      msg
    });
    this.clearAlertTimeout();
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ tc: false });
      }.bind(this),
      4000
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.tc && this.state.msg && (
          <Snackbar
            place="tc"
            color="danger"
            icon={ErrAlert}
            message={this.state.msg || ""}
            open={this.state.tc}
            closeNotification={() => this.setState({ tc: false })}
            close
          />
        )}
        <AuthConsumer>
          {({ isLoading, userInfo, error, refreshAuth }) => {
            if (isLoading) {
              return <div />;
            }
            if (error) {
              return (
                <div className={classes.layout}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card>
                        <CardHeader color="success">
                          <h4 className={classes.cardTitleWhite}>Login</h4>
                        </CardHeader>
                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Email"
                                id="email"
                                name="email"
                                onChange={this.handleChanged}
                                formControlProps={{
                                  fullWidth: true
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText="Password"
                                id="password"
                                name="password"
                                type="password"
                                onChange={this.handleChanged}
                                formControlProps={{
                                  fullWidth: true
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                        <CardFooter>
                          <Button
                            color="success"
                            disabled={!this.state.licenseAvail}
                            onClick={() => {
                              MemberLogin(
                                this.state.email,
                                this.state.password
                              ).then(token => {
                                if (token === null || token === undefined) {
                                  this.showNotification("Invalid credentials");
                                } else {
                                  refreshAuth();
                                }
                              }).catch(error => {
                                console.log("error: ", error);
                              });
                            }}
                          >
                            Login
                          </Button>
                        </CardFooter>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </div>
              );
            } else {
              if (isLocal === "true"){
                if (this.state.licenseAvail){
                  if (userInfo !== null && userInfo !== undefined) {
                    return <Redirect to="/dashboard" />;
                  }
                } else {
                  return <div/>;
                }
              }
              else {
                if (userInfo !== null && userInfo !== undefined) {
                  return <Redirect to="/dashboard" />;
                }
              }
            }
          }}
        </AuthConsumer>
      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx